module.exports = __webpack_public_path__ + "static/media/depatu-splash.1520d4bd.gif";